import PrescriberPrescriptionsTable from './PrescriberPrescriptionsTable'

export default PrescriberPrescriptionsTable
